var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnergyArcTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0.3679461103307009 -0.88871378939126 418.7312096072248 111.01767276919233",
    width: 414.73,
    height: 107.02,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M401.75 36.35C402.51 35.44 403.42 34.68 405.03 34.95C405.38 34.97 405.72 35.04 406.04 35.17C406.34 35.28 406.61 35.44 406.83 35.62C407.04 35.82 407.2 36.04 407.27 36.27C407.36 36.5 407.37 36.73 407.3 36.96C407.73 37.32 407.94 37.75 407.92 38.2C407.9 38.65 407.62 39.06 407.15 39.38C406.59 41.18 405.1 42.79 402.94 43.93C397.81 46.87 393.82 50.51 388.94 53.64C387.6 54.55 386.54 55.76 384.93 56.56C383.58 57.22 381.92 57.61 380.85 57.06C379.77 56.51 380.21 55.43 380.78 54.58C382.39 52.35 384.33 50.25 386.58 48.29C390.87 44.49 395.48 40.86 400.42 37.43C400.93 37.11 401.38 36.74 401.75 36.35Z",
    id: "e9OCpcRg3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.95 94.59C400.56 98.79 390.82 103.37 385.21 99.13C380.93 95.92 346.75 70.31 342.48 67.11C336.91 62.93 346.62 58.37 352.22 62.57C360.76 68.97 390.67 91.38 394.95 94.59Z",
    id: "a1NypNXCpr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.63 29.44C273.98 29.12 273.59 37.11 265.19 37.41C258.83 37.66 207.96 39.63 201.6 39.88C193.31 40.2 193.7 32.22 202.04 31.9C214.75 31.41 259.27 29.69 265.63 29.44Z",
    id: "a10iiiZDMQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.77 28.29C104.32 24.88 110.77 31.71 104.17 35.11C99.19 37.7 59.36 58.46 54.38 61.05C47.88 64.43 41.44 57.63 47.98 54.23C57.94 49.04 92.8 30.88 97.77 28.29Z",
    id: "b4YnrJrAhz"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.61 11.77C301.97 12.23 299.89 20.09 291.49 19.6C285.13 19.24 234.22 16.4 227.86 16.05C219.56 15.58 221.64 7.74 229.98 8.22C242.71 8.93 287.25 11.41 293.61 11.77Z",
    id: "d2133MhuX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.63 3C112.85 0.25 117.8 7.6 110.54 10.34C105.04 12.44 61.1 29.18 55.61 31.28C48.45 34 43.5 26.68 50.71 23.93C61.69 19.75 100.14 5.09 105.63 3Z",
    id: "aauk3xUOk"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.61 52.33C383.39 55.82 374.02 61.67 367.22 58.16C363.77 56.4 336.19 42.26 332.74 40.49C326.04 37.02 335.4 31.17 342.21 34.67C349.09 38.2 373.17 50.57 376.61 52.33Z",
    id: "c3CAsXrzex"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24 9.88C197.08 7.64 200.46 15.91 192.58 18.15C188.6 19.28 156.77 28.38 152.79 29.52C145.01 31.71 141.64 23.45 149.5 21.2C157.45 18.94 185.27 11.01 189.24 9.88Z",
    id: "b4hSDjZbst"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.81 76.76C35.1 72.32 43.88 78.64 38.56 83.09C35.88 85.35 14.43 103.39 11.74 105.65C6.47 110.03 -2.29 103.72 3.01 99.26C8.37 94.76 27.13 79.01 29.81 76.76Z",
    id: "aG0u4ddXE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.69 18.03C349.84 21.87 358.94 25.74 367.31 29.93C371.76 32.04 375.9 34.34 379.7 36.79C381.05 37.72 382.23 38.92 381.1 39.42C379.97 39.92 377.21 39.52 374.87 38.75C371.95 37.84 369.76 36.52 367.19 35.53C358.24 32.05 350.23 28.09 340.99 24.79C337.3 23.59 334.25 21.89 332.14 19.88C330.2 18.96 329.71 18.11 330.48 17.31C329.39 16.04 330.62 15.44 332.53 15.22C334.65 15.05 336.46 15.93 338.08 16.88C338.89 17.3 339.77 17.69 340.69 18.03Z",
    id: "bqoqoH0lw"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.37 12.99C136.82 9.72 146.29 6.5 155.82 3.86C160.74 2.4 165.74 1.21 170.78 0.3C172.65 0.01 174.78 -0.04 174.87 0.87C174.97 1.78 173.1 3.15 170.96 4.1C168.35 5.31 165.57 5.88 163.02 6.84C154.14 10.18 145.08 12.73 136.28 16.33C132.92 17.83 129.23 18.7 125.59 18.87C123.44 19.51 122.1 19.34 121.44 18.49C119.25 18.45 119.08 17.43 119.74 16.22C120.54 14.91 122.58 14.33 124.6 13.89C125.54 13.64 126.47 13.34 127.37 12.99Z",
    id: "a22myQRjso"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.39 66.51C390.97 66.13 390.82 65.69 390.97 65.28C391.11 64.87 391.53 64.51 392.16 64.27C392.17 64.05 392.28 63.83 392.46 63.64C392.64 63.44 392.9 63.27 393.22 63.14C393.54 63 393.92 62.91 394.32 62.86C394.72 62.81 395.14 62.81 395.56 62.85C397.52 62.91 398.25 63.82 398.78 64.76C399.07 65.19 399.44 65.61 399.9 66C404.26 70.06 408.18 74.24 411.64 78.52C413.49 80.75 414.93 83.07 415.93 85.42C416.26 86.31 416.2 87.4 414.9 87.68C413.59 87.95 411.69 87.31 410.39 86.46C408.77 85.4 408.1 84.1 406.9 83.03C402.46 79.26 399.25 75.18 394.48 71.46C392.43 70.01 391.33 68.26 391.39 66.51Z",
    id: "a1FILgH5vr"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.08 47.24C317.64 47.54 318.25 47.8 318.9 48C320.37 48.4 321.64 48.92 321.47 50.02C321.49 50.26 321.43 50.49 321.3 50.71C321.17 50.93 320.97 51.13 320.71 51.29C320.46 51.45 320.16 51.58 319.83 51.66C319.49 51.74 319.14 51.77 318.78 51.76C318.32 52.08 317.69 52.27 317.02 52.31C316.35 52.34 315.68 52.2 315.14 51.93C312.36 51.76 309.74 50.95 307.73 49.64C302.58 46.57 296.57 44.33 291.16 41.45C289.6 40.66 287.65 40.09 286.2 39.11C285.03 38.29 284.21 37.24 284.88 36.46C285.55 35.68 287.22 35.85 288.58 36.14C292.15 36.95 295.58 38.01 298.84 39.28C305.15 41.69 311.24 44.35 317.08 47.24Z",
    id: "aZ5RdJycs"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.91 38.89C150.57 38.72 151.21 38.51 151.79 38.24C153.03 37.6 154.32 37.14 155.66 37.81C155.98 37.92 156.25 38.08 156.47 38.27C156.69 38.46 156.85 38.67 156.94 38.91C157.03 39.14 157.05 39.38 156.99 39.61C156.93 39.84 156.8 40.06 156.6 40.26C156.79 40.69 156.74 41.15 156.45 41.55C156.17 41.96 155.66 42.27 155.04 42.44C153.47 43.95 151.14 45.04 148.45 45.52C141.95 46.88 136.1 49.17 129.71 50.78C127.93 51.27 126.24 52.1 124.26 52.42C122.63 52.67 120.86 52.59 120.18 51.81C119.5 51.02 120.53 50.14 121.57 49.51C124.37 47.88 127.42 46.45 130.66 45.24C136.88 42.87 143.31 40.75 149.91 38.89Z",
    id: "evIrcFJEn"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.96 69.48C13.45 69.81 13 70.17 12.61 70.57C11.85 71.48 10.94 72.24 9.32 71.97C8.96 71.94 8.62 71.86 8.31 71.74C8 71.63 7.72 71.46 7.51 71.27C7.3 71.08 7.14 70.86 7.06 70.63C6.98 70.4 6.97 70.16 7.04 69.93C6.61 69.57 6.39 69.13 6.42 68.68C6.46 68.24 6.73 67.82 7.2 67.5C7.77 65.69 9.28 64.08 11.46 62.95C16.63 60.01 20.66 56.38 25.57 53.24C26.92 52.33 27.99 51.13 29.62 50.32C30.97 49.67 32.63 49.29 33.72 49.84C34.8 50.4 34.35 51.48 33.77 52.33C32.15 54.57 30.18 56.68 27.91 58.64C23.59 62.44 18.93 66.06 13.96 69.48Z",
    id: "a5Gt20yi7e"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e9OCpcRg3",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e9OCpcRg3",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1NypNXCpr",
    opacity: 1,
    fill: "#faa629",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1NypNXCpr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a10iiiZDMQ",
    opacity: 1,
    fill: "#00afef",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a10iiiZDMQ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4YnrJrAhz",
    opacity: 1,
    fill: "#35ce8d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4YnrJrAhz",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2133MhuX",
    opacity: 1,
    fill: "#59fac3",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d2133MhuX",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aauk3xUOk",
    opacity: 1,
    fill: "#ffff3b",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aauk3xUOk",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3CAsXrzex",
    opacity: 1,
    fill: "#ffff3b",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c3CAsXrzex",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4hSDjZbst",
    opacity: 1,
    fill: "#faa629",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4hSDjZbst",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aG0u4ddXE",
    opacity: 1,
    fill: "#faa629",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aG0u4ddXE",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqoqoH0lw",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bqoqoH0lw",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a22myQRjso",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a22myQRjso",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1FILgH5vr",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1FILgH5vr",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aZ5RdJycs",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aZ5RdJycs",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#evIrcFJEn",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#evIrcFJEn",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5Gt20yi7e",
    opacity: 1,
    fill: "#08576d",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a5Gt20yi7e",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyArcTop);
export default __webpack_public_path__ + "static/media/energy-arc-top.ccb4bbe6fbc668f6c93d4323254c4d98.svg";
export { ForwardRef as ReactComponent };